export default "__VITE_ASSET__CAjwCMJp__"